module.exports = __webpack_public_path__ + "static/img/recruitment.4af590a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/recruitment.jpg
// module id = EtqC
// module chunks = 6